import React, { useState, useEffect } from 'react';
import { Box, Divider } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import { Typography } from '@mui/material';

type Props = {
  mdAlias: string,
};

const Articles: React.FC<Props> = ({ mdAlias }) => {
  const [article, setArticle] = useState<string>('');

  useEffect(() => {
    fetch(mdAlias)
      .then(res => res.text())
      .then(res => setArticle(res))
      .catch(err => console.log(err))
  },
    [mdAlias]
  );

  return (
    <Box sx={{ m: 2 }}>
      <ReactMarkdown
        children={article}
        components={{
          p: ({ children }) => <Typography paragraph>{children}</Typography>,
          h1: ({ children }) => <Typography variant='h4' sx={{ marginY: 2 }}>{children}</Typography>,
          h2: ({ children }) => (
            <Box>
              <Typography variant='h5'>{children}</Typography>
              <Divider sx={{ marginY: 2 }} />
            </Box>
          ),
        }}
      />
    </Box>
  );
};

export default Articles;
